import React from "react"
import { useDispatch } from "react-redux"
import { ModalFreezeFarmer } from "./ModalFreezeFarmer.jsx"
import { ModalBlacklistFarmer } from "./ModalBlacklistFarmer.jsx"
import { ModalUnfreezeFarmer } from "./ModalUnfreezeFarmer.jsx"
import { blacklistFarmers, freezeFarmers, unfreezeFarmers } from "../../../../../redux/actions/FarmerAction.jsx"
import { isFrozen } from "../../../../../constants/StringConstant.js"

export function FarmerListModals({
  showFreezeModal,
  showBlacklistModal,
  showUnfreezeModal,
  freezeItems,
  blacklistItems,
  unfreezeItems,
  onModalClose,
  onFreezePostSubmit,
  onBlacklistPostSubmit,
  onUnfreezePostSubmit
}) {
  const dispatch = useDispatch()

  return (
    <>
      <ModalFreezeFarmer
        show={showFreezeModal}
        onClose={onModalClose}
        onSubmit={(values) => {
          dispatch(freezeFarmers({
            document: {
              name: values.file_name,
              size: values.file_size,
              url: values.file_contract_url
            },
            reason: values.reason,
            farmer_ids: freezeItems.map((item) => item.id)
          }))
          onModalClose()
          onFreezePostSubmit()
        }}
      />
      <ModalBlacklistFarmer
        show={showBlacklistModal}
        onClose={onModalClose}
        onSubmit={(values) => {
          dispatch(blacklistFarmers({
            document: {
              name: values.file_name,
              size: values.file_size,
              url: values.file_contract_url
            },
            reason: values.reason,
            farmer_ids: blacklistItems.map((item) => item.id)
          }))
          onModalClose()
          onBlacklistPostSubmit()
        }}
      />
      <ModalUnfreezeFarmer
        show={showUnfreezeModal}
        onClose={onModalClose}
        onSubmit={(values) => {
          const frozenItems = unfreezeItems.filter((item) => isFrozen(item.farmer_status))
          dispatch(unfreezeFarmers({
            reason: values.reason,
            farmer_ids: frozenItems.map((item) => item.id)
          }))
          onModalClose()
          onUnfreezePostSubmit()
        }}
      />
    </>
  )
}
